<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ unidade.id ? "Editar" : "Adicionar" }} Unidade
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="unidade.nome" placeholder="" />
                    </div>

                    <div class="form-group col-md-2">
                      <label for="Name">
                        <span class="required">*</span> Sigla:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="unidade.sigla" placeholder="" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="Name">
                        <span class="required">*</span> CNES:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="unidade.cnes" placeholder="" />
                    </div>

                    <div class="form-group col-md-2">
                      <label for="Name">
                        <span class="required">*</span> CEP:
                      </label>
                      <input autocomplete="new-password" id="Name" v-model="unidade.cep" placeholder="" type="tel"
                        class="form-control" v-on:keyup="buscar" v-mask="'99999-999'" />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Logradouro:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="unidade.logradouro" placeholder="" />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Bairro:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="unidade.bairro" placeholder="" />
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Name"> Complemento: </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="unidade.complemento" placeholder="" />
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Name">
                        <span class="required">*</span> Número:
                      </label>
                      <input autocomplete="new-password" type="text" class="form-control" v-model="unidade.numero"
                        placeholder="" id="inputNumero" />
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Name">
                        <span class="required">*</span> Estado:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="unidade.estado" placeholder="" />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Cidade:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="unidade.cidade" placeholder="" />
                    </div>

                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Pais:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="unidade.pais" placeholder="" />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="TipoServico">
                        <span class="required">*</span> Tipo de Serviço:
                      </label>
                      <select id="TipoServico" class="form-control" v-model="unidade.tipo_servico">
                        <option value="">Selecione</option>
                        <option value="TIH">TIH</option>
                        <option value="SAMU">SAMU</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Veiculo">Veículo:</label>
                      <v-select v-model="unidade.veiculo_id" class="vselect" :options="veiculos"
                        :reduce="(veiculo) => veiculo.id" :label="'nome'"
                        :get-option-label="(veiculo) => `${veiculo.nome} ${veiculo.placa ? '- ' + veiculo.placa : ''}`"
                        placeholder="Selecione um veículo" />
                    </div>
                  </div>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/unidades" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      unidade: {
        nome: "",
        logradouro: "",
        bairro: "",
        complemento: "",
        cep: "",
        pais: "",
        sigla: "",
        numero: "",
        veiculo_id: "",
        tipo_servico: "",
      },

      veiculos: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "unidades";

      if (self.unidade.id) {
        self.unidade._method = "PUT";
        api += "/" + self.unidade.id;
      }

      axios
        .post(api, self.unidade)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/unidades");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidade: function (id) {
      const self = this;
      const api = self.$store.state.api + "unidades/" + id;

      axios
        .get(api)
        .then((response) => {
          self.unidade = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getVeiculos: function () {
      const self = this;
      let api = self.$store.state.api + "veiculos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.veiculos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.unidade.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.unidade.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.unidade.logradouro = self.endereco.logradouro;
            self.unidade.bairro = self.endereco.bairro;
            self.unidade.estado = self.endereco.uf;
            self.unidade.cidade = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
  },
  mounted: function () {
    const self = this;
    self.getVeiculos();

    let id = self.$route.params.id;
    if (id) {
      self.getUnidade(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>